import React, { Component } from "react"
import { withRouter } from "react-router-dom";
import MetaTags from 'react-meta-tags';
import Qrcode from "qrcode.react";
import PropTypes from 'prop-types';

//Verification code package
import { connect } from "react-redux";
import AuthCode from "react-auth-code-input"

import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Row,
} from "reactstrap"

import { apiError, verify2fCode, } from "../../store/actions";
// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-ligth-new.png"

//i18n
import { withTranslation } from "react-i18next"

class TwostepReadQr extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sixDigit:""
    }
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleValidSubmit(event, values) {
    const verify = {
      verificationCode: this.state.sixDigit,
      QrString: localStorage.getItem("qrString"),
    };
    this.props.verify2fCode(verify, this.props.history);
  }

  handleOnChange = (res) => {
    this.setState({sixDigit:res});
  };


  render() {
    return (
      <React.Fragment>
        <div className="account-pages my-5 pt-sm-5">
          <MetaTags>
            <title>{this.props.t("verifyQr")} | Wechip Payment Tools</title>
          </MetaTags>
          <Container>
           
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card>
                  <CardBody>
                    <div className="p-1">
                      <div className="text-center">
                        <div className="avatar-md mx-auto">
                          <div className="avatar-title rounded-circle bg-light">
                            <i className="bx bxs-key h1 mb-0 text-primary"></i>
                          </div>
                        </div>
                        <div className="p-2 mt-4">
                          <h4>{this.props.t("readQrcodeWithAuthenticator")}</h4>
                          <Qrcode value={`otpauth://totp/WeChip:${localStorage.getItem("username")}?secret=${localStorage.getItem("qrString")}&period=30&digits=6&algorithm=SHA1&issuer=WeChip`} />
                          <p className="mb-5">
                          <br />
                          <br />
                            <span className="font-weight-semibold">
                            {this.props.t("pleaseEnterThe6DigitCodeSentTo")}{" "}
                            </span>
                          </p>

                          <Form>
                            <Row>
                              <Col xs={12}>
                                <FormGroup className="verification">
                                  <label
                                    htmlFor="digit1-input"
                                    className="sr-only"
                                  >
                                    {this.props.t("digit1")}
                                  </label>
                                  <AuthCode
                                    characters={6}
                                    onChange={this.handleOnChange}
                                    name="sixDigit"
                                    className="form-control form-control-lg text-center"
                                    allowedCharacters="^[0-9]"
                                    value={this.state.sixDigit}
                                    inputStyle={{
                                      width: "40px",
                                      height: "42px",
                                      padding: "8px",
                                      borderRadius: "8px",
                                      fontSize: "16px",
                                      textAlign: "center",
                                      marginRight: "15px",
                                      border: "1px solid #ced4da",
                                      textTransform: "uppercase",
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </Form>

                          <div className="mt-4">
                          <button
                            className="btn btn-primary btn-block"
                            onClick={this.handleValidSubmit}
                          >
                            {this.props.t("confirmButton")}
                          </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  
                  <p>
                    © {new Date().getFullYear()}  Wechip 
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  } 
}

TwostepReadQr.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  verify2fCode: PropTypes.func,
  t: PropTypes.any
};


 
const mapStateToProps = state => {
  const { error } = state;
  return { error };
};
 
export default withRouter(
  connect(mapStateToProps, { verify2fCode, apiError })(withTranslation()(TwostepReadQr))
);
 
